module.exports = __webpack_public_path__ + "static/icons-basic-b57bcbb694f8e454c9c01d76c6395e0f.png";